import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import questionConfigs from 'modules/reviews/store/collections/questionConfigs'
import type QuestionConfig from 'modules/reviews/store/models/QuestionConfig'

interface IQuestionCategory {
  [key: string]: any
}

class QuestionCategory extends Model<IQuestionCategory> {
  constructor(attr: IQuestionCategory = {}) {
    super(attr)
    makeObservable(this, {
      questionConfigs: computed,
      archivedQuestionConfigs: computed,
    })
  }

  static urlRoot() {
    return '/surveys/question_categories'
  }

  get indexes() {
    return ['surveys_form_id']
  }

  get name(): string {
    return this.attributes.name
  }

  get questionConfigs(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_category_id: this.attributes.id,
      archived: false,
    })
  }

  get archivedQuestionConfigs(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_category_id: this.attributes.id,
      archived: true,
    })
  }
}

export default QuestionCategory
